import {
  AfterViewInit,
  Compiler,
  Component,
  EventEmitter,
  Injector,
  Input,
  NgModuleFactory,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ComponentStyle, IAbcComponent, StylingMode } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import {
  IInput,
  InputMode,
  InputStyle,
  InputType,
  InputValidationStatus,
  ShowMaskMode,
  ValueChangeEvent,
} from './abcInput';

@Component({
  selector: 'abcInput',
  template: '<ng-template #abcInput></ng-template>',
})
export class AbcInputComponent implements IAbcComponent, OnInit, AfterViewInit, OnDestroy {
  @Output() newObj: string; // OLD CODE
  @Output() onChange = new EventEmitter();
  @Output() onTextBoxInput = new EventEmitter();
  @Output() onbuttonClick = new EventEmitter();
  @Output() valueChange = new EventEmitter();
  @ViewChild('abcInput', { static: false, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input() id: string;
  @Input() editMask: string;

  private _label: string;
  private _placeholderLabel: string;
  private _symbol: string;
  private _type: InputType;
  private _value: any;
  private _inputButton: boolean;
  private _matRequired: boolean;
  private _decimalDigits: Number;
  private _maxLength: number;
  private componentRef;
  public htmlAttributes: IInput;
  private eventListener = [];
  private _visible: boolean;
  private _focusStateEnabled: boolean;
  private _isValid: boolean;
  private _mode: InputMode;
  private _name: string;
  private _readOnly: boolean;
  private _showClearButton: boolean;
  private _showMaskMode: ShowMaskMode;
  private _stylingMode: StylingMode;
  private _validationStatus: InputValidationStatus;
  private _rtlEnabled: boolean;
  private _width: string | number;
  private _height: string | number;
  private _disabled: boolean;
  private _style: ComponentStyle;
  private _class: string;
  private _step: number;
  private _min: number;
  private _max: number;
  private _showSpinButtons: boolean;
  private _valueChangeEvent: ValueChangeEvent;
  private _inputAttr: any;

  @Input()
  get style() {
    return this._style;
  }
  set style(data: ComponentStyle) {
    this._style = data;

    if (this.componentRef) {
      this.viewContainerRef.clear();
      this.createComponentInstance().subscribe((component) => {
        this.eventListener.forEach((element) => {
          component.addEventListener(element.type, element.listener);
        });
      });
    }
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data: string | number) {
    this._height = data;
    if (this.componentRef) {
      this.componentRef.height = data;
    }
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data: string | number) {
    this._width = data;
    if (this.componentRef) {
      this.componentRef.width = data;
    }
  }

  @Input()
  get showSpinButtons() {
    return this._showSpinButtons;
  }
  set showSpinButtons(data: boolean) {
    this._showSpinButtons = data;
    if (this.componentRef) {
      this.componentRef.showSpinButtons = data;
    }
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data: boolean) {
    this._disabled = data;
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
  }

  @Input()
  get maxLength() {
    return this._maxLength;
  }
  set maxLength(data: number) {
    this._maxLength = data;
    if (this.componentRef) {
      this.componentRef.maxLength = data;
    }
  }

  @Input()
  get min() {
    return this._min;
  }
  set min(data: number) {
    this._min = data;
    if (this.componentRef) {
      this.componentRef.min = data;
    }
  }

  @Input()
  get max() {
    return this._max;
  }
  set max(data: number) {
    this._max = data;
    if (this.componentRef) {
      this.componentRef.max = data;
    }
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data: boolean) {
    this._visible = data;
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
  }

  @Input()
  get isValid() {
    return this._isValid;
  }
  set isValid(data: boolean) {
    this._isValid = data;
    if (this.componentRef) {
      this.componentRef.isValid = data;
    }
  }

  @Input()
  get mode() {
    return this._mode;
  }
  set mode(data: InputMode) {
    this._mode = data;
    if (this.componentRef) {
      this.componentRef.mode = data;
    }
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data: string) {
    this._class = data;
    if (this.componentRef) {
      this.componentRef.class = data;
    }
  }

  @Input()
  get showClearButton() {
    return this._showClearButton;
  }
  set showClearButton(data: boolean) {
    this._showClearButton = data;
    if (this.componentRef) {
      this.componentRef.showClearButton = data;
    }
  }

  @Input()
  get inputAttr() {
    return this._inputAttr;
  }
  set inputAttr(data: any) {
    this._inputAttr = data;
    if (this.componentRef) {
      this.componentRef.inputAttr = data;
    }
  }

  @Input()
  get readOnly() {
    return this._readOnly;
  }
  set readOnly(data: boolean) {
    this._readOnly = data;
    if (this.componentRef) {
      this.componentRef.readOnly = data;
    }
  }
  @Input()
  get name() {
    return this._name;
  }
  set name(data: string) {
    this._name = data;
    if (this.componentRef) {
      this.componentRef.name = data;
    }
  }

  @Input()
  get showMaskMode() {
    return this._showMaskMode;
  }
  set showMaskMode(data: ShowMaskMode) {
    this._showMaskMode = data;
    if (this.componentRef) {
      this.componentRef.showMaskMode = data;
    }
  }

  @Input()
  get stylingMode() {
    return this._stylingMode;
  }
  set stylingMode(data: StylingMode) {
    this._stylingMode = data;
    if (this.componentRef) {
      this.componentRef.stylingMode = data;
    }
  }

  @Input()
  get validationStatus() {
    return this._validationStatus;
  }
  set validationStatus(data: InputValidationStatus) {
    this._validationStatus = data;
    if (this.componentRef) {
      this.componentRef.validationStatus = data;
    }
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data: boolean) {
    this._rtlEnabled = data;
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
  }
  @Input()
  get inputButton() {
    return this._inputButton;
  }
  set inputButton(data: boolean) {
    this._inputButton = data;
    if (this.componentRef) {
      this.componentRef.inputButton = data;
    }
  }

  @Input()
  get matRequired() {
    return this._matRequired;
  }
  set matRequired(isRequired: boolean) {
    this._matRequired = isRequired;
    if (this.componentRef) {
      this.componentRef.matRequired = isRequired;
    }
  }

  @Input()
  get focusStateEnabled() {
    return this._focusStateEnabled;
  }
  set focusStateEnabled(data: boolean) {
    this._focusStateEnabled = data;
    if (this.componentRef) {
      this.componentRef.focusStateEnabled = data;
    }
  }

  @Input()
  get step() {
    return this._step;
  }
  set hestepght(step: number) {
    this._step = step;
    if (this.componentRef) {
      this.componentRef.step = step;
    }
  }
  @Input()
  get label(): string {
    return this._label;
  }
  set label(labelValue: string) {
    this._label = labelValue;

    if (this.componentRef) {
      this.componentRef.label = this._label;
    }
  }

  @Input()
  get placeholder(): string {
    return this._placeholderLabel;
  }
  set placeholder(placeholderValue: string) {
    if (placeholderValue) {
      this._placeholderLabel = placeholderValue;
    }

    if (this.componentRef) {
      this.componentRef.placeholder = this._placeholderLabel;
    }
  }

  @Input()
  get value(): any {
    return this._value;
  }
  set value(value: any) {
    this._value = value;
    if (this.componentRef) {
      if (this.componentRef.type === 'number' && value) {
        this.componentRef.value = parseFloat(value);
        this._value = parseFloat(value);
      } else {
        this.componentRef.value = value;
      }
      // if (this.style == ComponentStyle.Material) this.componentRef.resizeInput(value);
    }
  }

  @Input()
  get symbol(): string {
    return this._symbol;
  }
  set symbol(symbolValue: string) {
    if (symbolValue) {
      this._symbol = symbolValue;
    }
    if (this.componentRef) {
      this.componentRef.symbol = this._symbol;
    }
  }
  @Input()
  get type(): InputType {
    return this._type;
  }
  set type(typeValue: InputType) {
    if (typeValue) {
      this._type = typeValue;
    } else {
      this._type = InputType.text;
    }
    if (this.componentRef) {
      this.componentRef.type = this._type;
    }
  }

  @Input()
  get valueChangeEvent() {
    return this._valueChangeEvent;
  }
  set valueChangeEvent(data) {
    if (this.componentRef) {
      this.componentRef.valueChangeEvent = data;
    }
    this._valueChangeEvent = data;
  }

  get decimalDigits(): Number {
    return this._decimalDigits;
  }
  set decimalDigits(value: Number) {
    this._decimalDigits = value;
  }

  constructor(
    private abcComponentService: AbcComponentService,
    private compiler: Compiler,
    private injector: Injector
  ) {
    this.style = ComponentStyle.Material;
    this.rtlEnabled = this.abcComponentService.rtlEnabled;
  }

  ngOnInit(): void {
    this.setInputsAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit(): void {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.Material: {
          import('../../../material/src/matInput/matInput.module').then((module) => {
            this.compiler.compileModuleAsync(module.MatInputModule).then((moduleFactory: NgModuleFactory<any>) => {
              const moduleRef = moduleFactory.create(this.injector);
              const componentFactory = moduleRef.instance.resolveComponent();
              this.componentRef = this.abcComponentService.loadComponent(
                componentFactory.componentType,
                this.viewContainerRef
              ).componentRef.instance;
              this.componentRef.onChange.subscribe((event) => {
                this.dataChange(event);
              });
              this.setAttributes(this.componentRef);
              observer.next(this.componentRef);
            });
          });
          break;
        }
        case ComponentStyle.DevExpress: {
          import('../../../devExtreme/src/devExInput/devExInput.module').then((module) => {
            this.compiler.compileModuleAsync(module.DexExInputModule).then((moduleFactory: NgModuleFactory<any>) => {
              const moduleRef = moduleFactory.create(this.injector);
              const componentFactory = moduleRef.instance.resolveComponent();
              this.componentRef = this.abcComponentService.loadComponent(
                componentFactory.componentType,
                this.viewContainerRef
              ).componentRef.instance;
              this.setAttributes(this.componentRef);
              this.componentRef.onChange.subscribe((event) => {
                this.dataChange(event);
              });
              this.componentRef.onTextBoxInput.subscribe((event) => {
                this.textBoxInput(event);
              });
              this.componentRef.valueChange.subscribe((event) => {
                this._value = event;
                this.valueChange.emit(event);
              });
              this.componentRef.onbuttonClick.subscribe((event) => {
                this.buttonClick(event);
              });
              observer.next(this.componentRef);
            });
          });

          break;
        }
      }
    });
    return observable;
  }

  setAttributes(componentRef: IInput) {
    if (this.htmlAttributes.id) componentRef.id = this.htmlAttributes.id;
    if (this.htmlAttributes.label) componentRef.label = this.htmlAttributes.label;
    if (this.htmlAttributes.placeholder) componentRef.placeholder = this.htmlAttributes.placeholder;
    if (this.htmlAttributes.type) componentRef.type = this.htmlAttributes.type;
    if (this.htmlAttributes.symbol) componentRef.symbol = this.htmlAttributes.symbol;
    if (this.htmlAttributes.mode) componentRef.mode = this.htmlAttributes.mode;
    if (this.htmlAttributes.decimalDigits) componentRef.decimalDigits = this.htmlAttributes.decimalDigits;
    if (this.htmlAttributes.class) componentRef.class = this.htmlAttributes.class;
    if (this.htmlAttributes.value) componentRef.value = this.htmlAttributes.value;
    if (this.inputButton) componentRef.inputButton = this.inputButton;
    if (this.matRequired) componentRef.matRequired = this.matRequired;
    if (this.mode) componentRef.mode = this.mode;
    if (this.htmlAttributes.editMask) componentRef.editMask = this.htmlAttributes.editMask;
    if (this.value) componentRef.value = this.value;
    if (this.symbol) componentRef.symbol = this.symbol;
    if (this.htmlAttributes.showSpinButtons) componentRef.showSpinButtons = this.htmlAttributes.showSpinButtons;
    if (this.htmlAttributes.showClearButton) componentRef.showClearButton = this.htmlAttributes.showClearButton;
    if (this.htmlAttributes.inputAttr) componentRef.inputAttr = this.htmlAttributes.inputAttr;
    this.componentRef.step = this.htmlAttributes.step ? this.htmlAttributes.step : 1;
    this.componentRef.min = this.htmlAttributes.min;
    this.componentRef.max = this.htmlAttributes.max;
    this.componentRef.rtlEnabled = this.rtlEnabled ? this.rtlEnabled : false;
    this.componentRef.visible = this.htmlAttributes.visible ? this.htmlAttributes.visible : true;
    this.componentRef.isValid = this.htmlAttributes.isValid ? this.htmlAttributes.isValid : true;
    this.componentRef.disabled = this.htmlAttributes.disabled ? this.htmlAttributes.disabled : false;
    this.componentRef.validationStatus = this.htmlAttributes.validationStatus
      ? this.htmlAttributes.validationStatus
      : 'valid';
    this.componentRef.stylingMode = this.htmlAttributes.stylingMode
      ? this.htmlAttributes.stylingMode
      : this.abcComponentService.stylingMode;
    this.componentRef.valueChangeEvent = this.htmlAttributes.valueChangeEvent
      ? this.htmlAttributes.valueChangeEvent
      : 'change';
    if (this.readOnly) {
      this.componentRef.readOnly = this.readOnly;
    }
    componentRef.setInputStyle(this.htmlAttributes.setInputStyle());
  }

  setCustomDataAttributes(dataAttr: Object): void {
    this.componentRef.setCustomDataAttributes(dataAttr);
  }

  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ): void {
    // I had to push events in an Array because this function is called before components are loaded for some reason
    this.eventListener.push({ type, listener });
  }

  // If the component is created inside HTML
  setInputsAttributesIfAvailable(): void {
    if (this.id) {
      const style: InputStyle = {
        height: this.height ? this.height : 25,
        width: this.width ? this.width : '100%',
        maxLength: this.maxLength,
      };
      this.htmlAttributes = {
        id: this.id,
        editMask: this.editMask,
        type: InputType[this._type],
        symbol: this._symbol,
        label: this.label,
        placeholder: this.placeholder,
        value: this._value,
        inputButton: this.inputButton,
        matRequired: this.matRequired,
        visible: (this.visible = true),
        focusStateEnabled: this.focusStateEnabled,
        isValid: (this.isValid = true),
        mode: this.mode,
        name: this.name,
        step: this.step,
        min: this.min,
        max: this.max,
        showSpinButtons: this.showSpinButtons,
        inputAttr: this.inputAttr,
        readOnly: this.readOnly,
        disabled: this.disabled,
        showClearButton: this.showClearButton,
        showMaskMode: this.showMaskMode,
        stylingMode: this.stylingMode,
        validationStatus: this.validationStatus,
        rtlEnabled: this.rtlEnabled,
        decimalDigits: this._decimalDigits,
        class: this.class,
        valueChangeEvent: this.valueChangeEvent,
        setInputStyle: (_styleAttributes) => (_styleAttributes = style),
        setCustomDataAttributes: () => {
          //TODO
        },
      };
    }
  }

  private dataChange(newValue): void {
    this.onChange.emit({ newValue: newValue });
  }

  public textBoxInput(event): void {
    this.onTextBoxInput.emit(event);
  }

  public buttonClick(event): void {
    this.onbuttonClick.emit(event);
  }

  public reset(): void {
    this.componentRef.reset();
  }
}
